import { StyleSheet } from "aphrodite/no-important";
import { autofill } from "redux-form";
import { colour, width } from "../style/base-theme";

const buttonDefaults = {
  width: "100%",
  padding: 10,
  display: "block",
  color: "#ffffff",
  textDecoration: "none",
  textAlign: "center",
  fontWeight: 700,
  fontSize: 18,
  border: 0,
  borderRadius: 30,
  cursor: "pointer",
  ":disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
};

export const styles = StyleSheet.create({
  container: {
    padding: 20,
    maxWidth: width.outer,
    margin: "0 auto",
  },
  gap: {
    height: 20,
  },
  mainContainer: {
    minWidth: 320,
    maxWidth: width.innerNarrow,
    margin: "0 auto",
    padding: "0 20px 100px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px solid ${colour.grey[500]}`,
    paddingBottom: 20,
    marginBottom: 20,
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: colour.grey[100],
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    paddingLeft: 15,
  },
  radioLabel: { marginLeft: 10 },
  label: {
    fontSize: 16,
    color: colour.grey[300],
    margin: 0,
    marginBottom: 5,
    display: "block",
    padding: 0,
    fontWeight: 600,
  },
  unitsWarning: {
    display: "flex",
    marginBottom: 10,
  },
  unitsWarningMicrocopy: {
    margin: "0 0 0 10px",
  },
  microcopy: {
    fontSize: 14,
    color: colour.grey[400],
    margin: 0,
    display: "block",
    marginBottom: 10,
    padding: 0,
  },
  inputWrapper: {
    position: "relative",
  },
  input: {
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: 500,
    padding: "15px 20px",
    marginBottom: 20,
    width: "100%",
    fontSize: 16,
    color: colour.grey[300],
    ":focus": {
      outline: 0,
      borderColor: colour.grey[400],
    },
  },
  inputError: {
    borderColor: "#D80000",
    marginBottom: 5,
  },
  inputDisabled: {
    border: 0,
    borderRadius: 500,
    padding: "15px 0",
    width: "100%",
    fontSize: 16,
    color: colour.grey[300],
    ":focus": {
      outline: 0,
    },
  },
  unit: {
    position: "absolute",
    right: 20,
    top: "50%",
    transform: "translateY(-50%)",
    fontStyle: "normal",
    color: colour.grey[400],
  },
  buttonRed: {
    ...buttonDefaults,
    background: colour.brand.red,
    marginTop: 20,
  },
  buttonGreen: {
    ...buttonDefaults,
    background: colour.brand.green,
  },
  buttonWhite: {
    ...buttonDefaults,
    background: "transparent",
    color: colour.grey[400],
    textAlign: "left",
    ":before": {
      content: '"\\e803"',
      fontFamily: "informetis",
      fontSize: 18,
      position: "relative",
      fontWeight: 600,
      marginRight: 5,
    },
  },
  subtitle: {
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[100],
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200],
  },
  whiteBox: {
    padding: 10,
    marginBottom: 20,
    marginLeft: -10,
    width: "calc(100% + 20px)",
  },
  greyBox: {
    padding: 10,
    background: colour.grey[600],
    borderRadius: 3,
    marginBottom: 20,
    marginLeft: -10,
    width: "calc(100% + 20px)",
  },
  flexField: {
    display: "flex",
    marginBottom: 15,
    justifyContent: "space-between",
    alignItems: "center",
  },
  flexLabel: {
    fontSize: 16,
    color: colour.grey[300],
    margin: 0,
    marginBottom: 17,
    display: "block",
    padding: 0,
    fontWeight: 600,
  },
  flexLine: {
    display: "flex",
    marginBottom: 15,
  },
  flexLeft: {
    flex: 1,
    color: colour.grey[300],
    fontSize: 16,
    fontWeight: 600,
  },
  flexRight: {
    flex: 1,
    textAlign: "right",
    color: colour.grey[300],
    fontSize: 16,
  },
  completeBox: {
    border: `1px solid ${colour.brand.blue}`,
    borderRadius: 4,
    color: colour.brand.blue,
    padding: "3px 10px",
    margin: "0 auto 30px",
    display: "table",
    textAlign: "center",
    fontWeight: 600,
    ":before": {
      content: '"\\e800"',
      fontFamily: "informetis",
      fontSize: 15,
      position: "relative",
      fontWeight: 400,
      marginRight: 5,
    },
    ":hover": {
      border: `1px solid ${colour.brand.blue}`,
    },
  },
  success: {
    border: `1px solid ${colour.brand.green}`,
    background: colour.brand.green,
    color: "#ffffff",
    ":before": {
      content: '"\\e820"',
      fontFamily: "informetis",
      fontSize: 15,
      position: "relative",
      fontWeight: 400,
      marginRight: 5,
    },
  },
  changeAnswers: {
    color: colour.grey[400],
    fontSize: 14,
    textAlign: "center",
    marginTop: 20,
  },
  accountIcon: {
    border: `1px solid ${colour.grey[400]}`,
    borderRadius: "50%",
  },
  lastRun: {
    textAlign: "center",
    display: "block",
    margin: 5,
    color: colour.grey[400],
    fontSize: 12,
    fontStyle: "italic",
  },
  divide: {
    margin: "20px auto",
    border: 0,
    height: 1,

    background: colour.grey[500],
  },
  error: {
    color: "#D80000",
    fontSize: 16,
    paddingBottom: 20,
    display: "block",
  },
  link: {
    color: colour.brand.blue,
    textDecoration: "underline",
    background: "none",
    outline: 0,
    border: 0,
    cursor: "pointer",
    fontSize: "inherit",
    display: "flex",
    alignItems: "center",
  },
  linkIcon: {
    marginRight: 5,
  },
  addLinkWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  addLink: {
    padding: 20,
    textAlign: "center",
  },
  twoColumn: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 15,
  },
  twoColumnItem: {
    flex: "1 0 0",
    width: "50%",
  },
  twoColumnItemLeading: {
    marginRight: 20,
  },
  applianceIconColumn: {
    display: "flex",
    marginBottom: 15,
    flexWrap: "wrap",
  },
  applianceIconColumnItem: {
    marginRight: 15,
    marginBottom: 15,
  },
  dataSection: {
    marginBottom: 20,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[200],
    margin: 0,
    padding: 0,
  },
  headerTitleBottomMargin: {
    marginBottom: 10,
  },
  headerTitleSmall: {
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200],
    margin: 0,
    padding: 0,
  },
  headerTitleLight: {
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[300],
    margin: 0,
    padding: 0,
  },
  paragraph: {
    fontSize: 18,
    fontWeight: 400,
    color: colour.grey[300],
    margin: "0 0 10px 0",
    padding: 0,
  },
  paragraphSmall: {
    fontSize: 16,
    fontWeight: 400,
    color: colour.grey[300],
    margin: "0 0 10px 0",
    padding: 0,
  },
  paragraphXSmall: {
    fontSize: 14,
    fontWeight: 400,
    color: colour.grey[300],
    margin: "0 0 10px 0",
    padding: 0,
  },
  smallMarginBottom: {
    marginBottom: 5,
  },
  block: {
   width: '100%',
   display: 'block',
  },
  hidden: {
    height: 0,
    width: 0,
    position: "absolute",
    left: 9999,
    display: "none",
  },
  checkbox: {
    border: `2px solid ${colour.grey[500]}`,
    height: 44,
    width: 44,
    padding: 8,
    borderRadius: 3,
    ":hover": {
      backgroundColor: colour.grey[500],
    },
  },
  checkboxWrapper: {
    display: "inline-flex",
    alignItems: "center",
    marginRight: 50,
    marginBottom: 10,
  },
  checkboxChecked: {
    background: colour.brand.blue,
    borderColor: colour.brand.blue,
    ":hover": {
      background: colour.brand.blue,
      borderColor: colour.brand.blue,
    },
  },
  radio: {
    border: `2px solid ${colour.grey[500]}`,
    height: 44,
    width: 44,
    padding: 10,
    borderRadius: 200,
    ":hover": {
      backgroundColor: colour.grey[500],
    },
  },
  radioIcon: {
    background: "#fff",
    display: "block",
    width: 20,
    height: 20,
    borderRadius: 200,
  },
  radioIconChecked: {
    background: colour.brand.blue,
  },
  hidden: {
    height: 0,
    width: 0,
    position: "absolute",
    left: 9999,
  },
  breakdownTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200],
    marginTop: 25,
    marginBottom: 15,
    display: "flex",
    justifyContent: "space-between",
  },
  breakdownToggle: {
    display: "flex",
  },
  breakdownTitleText: {
    alignSelf: "center",
    marginRight: 10,
  },
  breakdownToggleTitle: {
    marginRight: 5,
    alignSelf: "center",
  },
  breakdownToggleLabel: {
    display: "flex",
    margin: "0 10px",
    alignSelf: "center",
  },
  breakdownToggleUnit: {
    alignSelf: "center",
  },
  dataWrapper: {
    background: colour.grey[600],
    padding: "10px 10px 0 10px",
    marginBottom: 10,
  },
  dataWrapperTitle: {
    margin: 0,
  },
  backWrapper: {
    display: "flex",
  },
  backTitle: {
    padding: 10,
  },
  paragraphLeading: {
    flex: 1,
  },
  paragraphCenter: {
    flex: 1,
  },
  paragraphTrailing: {
    textAlign: "right",
  },
});
